import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null); // null = loading, false = guest
  const [credits, setCredits] = useState(null);
  const [settings, setSettings] = useState({});

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setCredits(data.credits);
      return data.user;
    } catch {
      setUser(false);
      setCredits(null);
      return false;
    }
  }, []);

  useEffect(() => {
    refresh();
    api.get("/public/settings").then(({ data }) => setSettings(data)).catch(() => {});
  }, [refresh]);

  const login = async (identifier, password) => {
    const { data } = await api.post("/auth/login", { identifier, password });
    setUser(data.user);
    setCredits(data.credits);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setUser(data.user);
    setCredits(data.credits);
    return data.user;
  };
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
    setCredits(null);
  };

  return (
    <AuthCtx.Provider value={{ user, credits, settings, setCredits, refresh, login, register, logout }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
